var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDltIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93.32,
    height: 93.319,
    viewBox: "0 0 93.32 93.319",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_149083",
    "data-name": "Group 149083",
    transform: "translate(-1.002 -1.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102263",
    "data-name": "Path 102263",
    d: "M51.628,2.286a6.779,6.779,0,0,1,9.735,1.931,6.781,6.781,0,0,0,7.329,3.036,6.779,6.779,0,0,1,8.255,5.514,6.781,6.781,0,0,0,5.609,5.609,6.779,6.779,0,0,1,5.514,8.253,6.781,6.781,0,0,0,3.036,7.331A6.779,6.779,0,0,1,93.038,43.7a6.779,6.779,0,0,0,0,7.933,6.779,6.779,0,0,1-1.931,9.735,6.781,6.781,0,0,0-3.035,7.329,6.779,6.779,0,0,1-5.516,8.255,6.781,6.781,0,0,0-5.609,5.609,6.779,6.779,0,0,1-8.253,5.514,6.781,6.781,0,0,0-7.331,3.036,6.779,6.779,0,0,1-9.735,1.931,6.779,6.779,0,0,0-7.933,0,6.779,6.779,0,0,1-9.735-1.931,6.781,6.781,0,0,0-7.329-3.035,6.779,6.779,0,0,1-8.255-5.516,6.781,6.781,0,0,0-5.609-5.609,6.779,6.779,0,0,1-5.514-8.255,6.781,6.781,0,0,0-3.036-7.329,6.779,6.779,0,0,1-1.931-9.735,6.779,6.779,0,0,0,0-7.933,6.779,6.779,0,0,1,1.931-9.735,6.781,6.781,0,0,0,3.036-7.329,6.779,6.779,0,0,1,5.514-8.255,6.781,6.781,0,0,0,5.609-5.609,6.779,6.779,0,0,1,8.255-5.514,6.781,6.781,0,0,0,7.329-3.036A6.779,6.779,0,0,1,43.7,2.286a6.779,6.779,0,0,0,7.933,0Z",
    transform: "translate(0)",
    fill: "#ffc7d6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9630",
    "data-name": "Ellipse 9630",
    cx: 38.618,
    cy: 38.618,
    r: 38.618,
    transform: "translate(9.044 9.044)",
    fill: "#cf0038"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102489",
    "data-name": "Path 102489",
    d: "M17.138,14.62,28.418,3.34A1.877,1.877,0,1,0,25.764.686l-11.28,11.28L3.2.686A1.877,1.877,0,0,0,.551,3.34L11.83,14.62.551,25.9A1.877,1.877,0,1,0,3.2,28.554l11.28-11.28,11.28,11.28A1.877,1.877,0,0,0,28.418,25.9Zm0,0",
    transform: "translate(33.178 33.042)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDltIcon);
export default __webpack_public_path__ + "static/media/dltIcon.8e7f32da861fceaaa74d3313f1bce913.svg";
export { ForwardRef as ReactComponent };